export default __webpack_public_path__ + "static/media/history.6f534ead.svg";